import React from 'react';
import {Navigate, Outlet} from 'react-router-dom';
import useAuthRole from '../../hooks/useAuthRole';

export default function RoleRoute({allowedRoles, redirectTo = '/exampage'}) {
    const {role, isRoleLoading} = useAuthRole();

    if (isRoleLoading) return <div className="api-message">در حال بررسی سطح دسترسی...</div>;
    return allowedRoles.includes(role) ? <Outlet/> : <Navigate to={redirectTo} replace/>;
}
